import 'font-awesome/css/font-awesome.min.css';
import "babel-polyfill";
import "raf/polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { StyledEngineProvider } from "@mui/material/styles";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./locales/i18n";
import { LicenseManager } from  'ag-grid-enterprise'
LicenseManager.setLicenseKey("[TRIAL]_this_AG_Grid_Enterprise_key( AG-047238 )is_granted_for_evaluation_only___Use_in_production_is_not_permitted___Please_report_misuse_to( legal@ag-grid.com )__For_help_with_purchasing_a_production_key_please_contact( info@ag-grid.com )__All_Front-End_JavaScript_developers_working_on_the_application_would_need_to_be_licensed___This_key_will_deactivate_on( 31 October 2023 )___[v2]_MTY5ODcxMDQwMDAwMA==79d599f48a9d39e35170430e849f6741")

const theme = createTheme({
  palette: {
    primary: {
      light: "#def1ea",
      main: "#0a5d66",
      dark: "#3b5847",
      contrastText: "#fff",
    },
    secondary: {
      light: "#ff7961",
      main: "#4fc3f7",
      dark: "#ba000d",
      contrastText: "#000",
    },
  },
});

ReactDOM.render(
  <React.Fragment>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </StyledEngineProvider>
  </React.Fragment>,
  document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();



// WEBPACK FOOTER //
// ./src/index.js